import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IPagination, IPaginationResultFrequencies } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "environments/environment.prod";
import { Observable } from "rxjs";
import {
  andAllWhere,
  andWhere,
  buildQuery,
  FilterFn,
  noop,
  Ops,
  orderBy,
  OrderVariant,
  orWhere,
  page,
  where,
} from "@albatrosdeveloper/ave-utils-npm/lib/utils/query.util";
import BusinessPartnerAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/business-partners/business-partner/business-partner.entity";
import { BusinessPartnerBySubRoute } from "app/modules/components/routing/sub-routes/interfaces/busines-partner-by-sub-route.interface";

const apiUrl = env.API_BUSINESS_PARTNER;
const moduleName = "business-partner";

@Injectable({
  providedIn: "root",
})
export class MapModalRouteService extends AbstractService<
  BusinessPartnerBySubRoute,
  Partial<BusinessPartnerBySubRoute>,
  Partial<BusinessPartnerBySubRoute>
> {

  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findAllWithCountBySubRoute(
    options: IPagination<BusinessPartnerAttributes>,
    subRouteId: string,
    type: boolean //Asignado o No asignado
  ): Observable<IPaginationResultFrequencies<BusinessPartnerBySubRoute>> {
    const query = buildQuery<BusinessPartnerAttributes>(
      where(
        "types.code" as keyof BusinessPartnerAttributes,
        Ops.notIn(...["BPT0004"])
      ),
      andAllWhere("_deleted", Ops.eq(false)),

      orderBy(
        options.sort ?? "name",
        options.sortDirection == "ASC" ? OrderVariant.Asc : OrderVariant.Desc
      ),
      //page(options.currentPage ?? 1, options.limitPerPage ?? 100)
    );

    const API_URL: string =
      apiUrl +
      `api/${moduleName}/bySubRoute/${subRouteId}?filter=${encodeURIComponent(JSON.stringify(query))}&assign=${type}`;
    return this.http.get<
      IPaginationResultFrequencies<BusinessPartnerBySubRoute>
    >(API_URL);
  }
}